import type React from 'react'
import { CalendarDays, Gift, PlayCircle } from 'lucide-react'
import { FaFacebook, FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa6'
import type { CampaignBriefData } from '@/hooks/useCampaign'

/** Fixed colours, so they read the same under the app's flipped light palette */
export const TONES = {
  lime: { chip: 'bg-[#E8F9D2] text-[#3F7A0A]', ring: 'border-[#9BD85A] bg-[#F6FDEE]' },
  purple: { chip: 'bg-[#F1E8FD] text-[#7C3AED]', ring: '' },
  blue: { chip: 'bg-[#E3EEFD] text-[#2563EB]', ring: '' },
  amber: { chip: 'bg-[#FEF3D7] text-[#B45309]', ring: '' },
} as const

export const PLATFORMS: {
  id: string
  icon: React.ComponentType<{ className?: string }>
  color: string
}[] = [
  { id: 'TikTok', icon: FaTiktok, color: 'text-[#111111]' },
  { id: 'Instagram', icon: FaInstagram, color: 'text-[#E1306C]' },
  { id: 'YouTube', icon: FaYoutube, color: 'text-[#FF0000]' },
  { id: 'Facebook', icon: FaFacebook, color: 'text-[#1877F2]' },
]

export type CampaignType = 'gifting' | 'licensing' | 'appearance'

/** The three kinds of campaign a brand can run */
export const CAMPAIGN_TYPES: {
  id: CampaignType
  label: string
  blurb: string
  icon: React.ComponentType<{ className?: string }>
  tone: keyof typeof TONES
}[] = [
  {
    id: 'gifting',
    label: 'Gifting',
    blurb: 'Send products to athletes; they post and earn bonuses as the views come in.',
    icon: Gift,
    tone: 'lime',
  },
  {
    id: 'licensing',
    label: 'Content Licensing',
    blurb: 'Athletes create content you approve and license for your paid media.',
    icon: PlayCircle,
    tone: 'purple',
  },
  {
    id: 'appearance',
    label: 'Appearances',
    blurb: 'Book athletes for events, store appearances or experiences.',
    icon: CalendarDays,
    tone: 'blue',
  },
]

export const DEFAULT_BRIEF: CampaignBriefData = {
  description: '',
  objectives: [],
  primaryKpi: '',
  targetAgeRange: '18–24',
  targetGender: 'All genders',
  targetLocation: 'National',
  targetAudienceDescription: '',
  primaryMessage: '',
  supportingPoints: ['', '', ''],
  cta: '',
  tones: [],
  creativeDirection: '',
  additionalNotes: '',
  productName: '',
  productDescription: '',
  productPhotoUrl: null,
  postsPerAthlete: 1,
}
